// extracted by mini-css-extract-plugin
export default {"tooltip":"Sn-z","sharingV2":"Tn-z","sharingIconsV2":"Un-z","links":"Vn-z","link":"Wn-z","facebookV2":"Xn-z","twitterV2":"Yn-z","pinterestV2":"Zn-z"};